import React from 'react'

export function OtherProject({git, live, title, description, stack}) {
  return (
    <div className="col-md-6 col-lg-4 col-12">
        <div className="project-alt mt-5">
            <div className='px-4 pt-4 pb-2 d-flex justify-content-between align-items-center'>
                <span className='span'></span>
                <div className="links">
                    {git && <a href={git}><i className="fab fa-github"></i></a>}
                    { live && <a href={live}><i class="fas fa-external-link-alt"></i></a> }
                </div>
            </div>
            <div className="px-4">
                <small className='text-capitalize fw-bold'>{title}</small>
                <p className='my-2'>{description}</p>
                <div className="tech-stack mt-4">
                        {/* <span>React.js</span>
                        <span>Tmdb Api</span>
                        <span>Netlify</span> */}
                        {stack && stack.map((tool, id) =>{
                            return <span className='text-capitalize' key={id}>{tool}</span>
                        })}
                </div>
            </div>
        </div>
    </div>
  )
}
